import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import {
  MDBContainer,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBCheckbox
}
  from 'mdb-react-ui-kit';
import styled from 'styled-components';

import axios from 'axios';

import { useNavigate } from 'react-router-dom'; // Import useHistory for navigation

import { selectAuth } from '../slices/authSlice';
import { useSelector, useDispatch } from 'react-redux'
import Accordion from 'react-bootstrap/Accordion';


const GreenTab = styled(MDBTabsLink)`
    background-color: green; /* Change to your desired shade of green */
    color: white; /* Change text color if needed */
`;

function CTAdminPage() {

  const [justifyActive, setJustifyActive] = useState('tab1');;
  const { isAuthenticated, userInformation } = useSelector(selectAuth);
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const [defis, setDefis] = useState([]);
  let [loadingData, setLoadingData] = React.useState(true);

  const handleJustifyClick = (value) => {
    if (value === justifyActive) {
      return;
    }

    setJustifyActive(value);
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await axios.get('/api/defisuploads/mytroupe/bydefi');
        if (response.status == 200) {
          console.log(response.data)
          setDefis(response.data)
        }
      } catch (error) {
        console.error('Error:', error);
        // Handle error appropriately, e.g., show an error message or dispatch a failure action
      } finally {
        setLoadingData(false)
      }

    };
    fetch();
  }, []);

  // Redirect to /login if not authenticated
  useEffect(() => {
    if (!isAuthenticated || !userInformation.CT) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated || !userInformation.CT) {
    return null; // Return null while redirecting
  }


  return (
    <Container>
      <h1 className="my-3">CT admin</h1>
      {/* <MDBContainer className="p-3 my-5 d-flex flex-column">

      <MDBTabs pills justify className='mb-3 d-flex flex-row justify-content-between'>
        <MDBTabsItem>
          <GreenTab onClick={() => handleJustifyClick('tab1')} active={justifyActive === 'tab1'} style={{
            backgroundColor: justifyActive === 'tab1' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab1' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            View by Defis
          </GreenTab>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleJustifyClick('tab2')} active={justifyActive === 'tab2'} style={{
            backgroundColor: justifyActive === 'tab2' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab2' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            View by Patrouilles
          </MDBTabsLink>
        </MDBTabsItem>
      </MDBTabs>

      <MDBTabsContent>

        <MDBTabsPane open={justifyActive === 'tab1'}>

       {tab1}

        </MDBTabsPane>

        <MDBTabsPane open={justifyActive === 'tab2'}>

         

        </MDBTabsPane>


      </MDBTabsContent>
    </MDBContainer> */}
      {loadingData ?
        (<></>)
        :
        (<Accordion defaultActiveKey="0">
          {
            defis.map((defi, index) => {
              return (
                <Accordion.Item eventKey={index}>
                  <Accordion.Header>{defi.title + " - " + defi.subtitle}</Accordion.Header>
                  <Accordion.Body>
                    <Accordion defaultActiveKey="0">
                      {
                        defi.patrouilles.map((patrouille, indexx) => {
                          return (
                            <Accordion.Item eventKey={indexx}>
                              <Accordion.Header>
                                {patrouille.totem}
                                {patrouille.defisuploads === null ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="red"
                                    viewBox="0 0 16 16"
                                    style={{ marginLeft: "8px" }}
                                  >
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                  </svg>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="green"
                                    viewBox="0 0 16 16"
                                    style={{ marginLeft: "8px" }}
                                  >
                                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
                                  </svg>
                                )}
                              </Accordion.Header>
                              <Accordion.Body>
                                {patrouille.defisuploads
                                  ? (<>
                                    <p>{patrouille.defisuploads.DefisUploadFiles.length + " "}File(s) Uploaded</p>
                                    <div style={styles.gallery}>
                                      {patrouille.defisuploads.DefisUploadFiles.map((uploadFile, index) => (
                                        <div key={index} style={styles.imageContainer}>
                                          <img
                                            src={"images/" + uploadFile.filename}
                                            alt={uploadFile.filename}
                                            style={styles.image}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  </>)
                                  : "No uploads"
                                }
                              </Accordion.Body>
                            </Accordion.Item>
                          )
                        })
                      }

                    </Accordion>
                  </Accordion.Body>
                </Accordion.Item>
              )
            })
          }

        </Accordion>
        )
      }
    </Container>
  );
}

const styles = {
  gallery: {
    display: "flex", // Use Flexbox
    flexWrap: "wrap", // Wrap images to the next line if they don't fit
    gap: "10px", // Space between images
  },
  imageContainer: {
    width: "100px", // Fixed width for each image container
    height: "100px",
    overflow: "hidden", // Hide overflow
    borderRadius: "8px", // Optional: Rounded corners
    border: "1px solid #ddd", // Optional: Add a border
  },
  image: {
    width: "100%", // Fill the container
    height: "100%",
    objectFit: "cover", // Ensure the image covers the container
  },
};

export default CTAdminPage;